<template>
  <div class="staff-arts-container">
    <Header ref="Headers" />

    <div v-if="loading" class="loading-wrap">
      <van-loading color="#ee0a24" size="24px">加载中...</van-loading>
    </div>

    <div v-else class="inner">
      <div class="main-title">
        <span>职工文艺</span>
      </div>

      <div v-if="subCategories.length > 0" class="sub-tabs">
        <div
          v-for="(item, idx) in subCategories"
          :key="item.categoryId + '-' + idx"
          :class="['sub-tab', { active: activeSub === idx }]"
          @click="setSubTab(idx)"
        >
          {{ item.categoryName }}
        </div>
      </div>

      <div v-if="loadingNews" class="loading-wrap small">
        <van-loading color="#ee0a24" size="24px">加载中...</van-loading>
      </div>
      <template v-else>
        <List :is-show-time="true" :data="list" />
        <EmptyState v-if="list.length === 0" />
        <van-pagination
          v-if="list.length > 0"
          @change="handlePageChange"
          v-model="currentPage"
          :total-items="total"
          :show-page-size="3"
          force-ellipses
        />
      </template>
    </div>

    <Footer />
  </div>
</template>

<script>
import Vue from "vue";
import { Pagination, Loading } from "vant";
import Footer from "@/components/footer.vue";
import Header from "@/components/header.vue";
import List from "@/components/list.vue";
import EmptyState from "@/components/EmptyState.vue";
import { getNewsList } from "@/request/api";
import { get } from "@/request/http";

Vue.use(Pagination);
Vue.use(Loading);

const STAFF_ARTS_ROOT = "508";

export default {
  name: "StaffArtsMore",
  components: {
    Header,
    Footer,
    List,
    EmptyState,
  },
  data() {
    return {
      loading: true,
      loadingNews: false,
      subCategories: [],
      activeSub: 0,
      list: [],
      limit: 8,
      page: 1,
      currentPage: 1,
      total: 0,
    };
  },
  methods: {
    normalizeSubRows(payload) {
      if (!payload) {
        return [];
      }
      if (Array.isArray(payload)) {
        return payload;
      }
      if (Array.isArray(payload.children)) {
        return payload.children;
      }
      if (Array.isArray(payload.list)) {
        return payload.list;
      }
      return [];
    },

    mapSubCategory(row) {
      let categoryId = "";
      if (row.categoryId !== undefined && row.categoryId !== null) {
        categoryId = String(row.categoryId);
      } else if (row.id !== undefined && row.id !== null) {
        categoryId = String(row.id);
      }
      const categoryName = row.categoryName || row.name || row.title || "子栏目";
      return { categoryId, categoryName };
    },

    loadCategories() {
      this.loading = true;
      get(`/gbs/portal/portal/cmsCategory?categoryId=${STAFF_ARTS_ROOT}`)
        .then((res) => {
          this.loading = false;
          if (res.code !== 0) {
            this.$Toast && this.$Toast.fail(res.msg);
            this.useFallbackSingleTab();
            return;
          }
          const raw = this.normalizeSubRows(res.data);
          const mapped = raw
            .map((r) => this.mapSubCategory(r))
            .filter((x) => x.categoryId);
          if (mapped.length === 0) {
            this.useFallbackSingleTab();
          } else {
            this.subCategories = mapped;
            this.activeSub = 0;
            this.page = 1;
            this.currentPage = 1;
            this.fetchNewsForCurrentTab();
          }
        })
        .catch(() => {
          this.loading = false;
          this.$Toast && this.$Toast.fail("加载失败");
          this.useFallbackSingleTab();
        });
    },

    useFallbackSingleTab() {
      this.subCategories = [
        { categoryId: STAFF_ARTS_ROOT, categoryName: "职工文艺" },
      ];
      this.activeSub = 0;
      this.page = 1;
      this.currentPage = 1;
      this.fetchNewsForCurrentTab();
    },

    getCurrentCategoryId() {
      const row = this.subCategories[this.activeSub];
      if (row && row.categoryId) {
        return row.categoryId;
      }
      return STAFF_ARTS_ROOT;
    },

    fetchNewsForCurrentTab() {
      const categoryId = this.getCurrentCategoryId();
      this.loadingNews = true;
      getNewsList({
        categoryId,
        page: this.page,
        limit: this.limit,
        title: "",
      })
        .then((res) => {
          this.loadingNews = false;
          if (res.code !== 0) {
            this.$Toast && this.$Toast.fail(res.msg);
            this.list = [];
            this.total = 0;
            return;
          }
          const rows = res.data.list || res.data;
          this.list = Array.isArray(rows) ? rows : [];
          this.total =
            res.data.total !== undefined && res.data.total !== null
              ? res.data.total
              : this.list.length;
        })
        .catch(() => {
          this.loadingNews = false;
          this.$Toast && this.$Toast.fail("网络异常");
          this.list = [];
          this.total = 0;
        });
    },

    setSubTab(idx) {
      if (idx === this.activeSub) {
        return;
      }
      this.activeSub = idx;
      this.page = 1;
      this.currentPage = 1;
      this.fetchNewsForCurrentTab();
    },

    handlePageChange() {
      this.page = this.currentPage;
      this.fetchNewsForCurrentTab();
    },
  },
  activated() {
    this.loadCategories();
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/variable.scss";

.staff-arts-container {
  background: #ffffff;
  position: relative;
  min-height: 100vh;
}

.loading-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 80px 0;

  &.small {
    padding: 40px 0;
  }
}

.inner {
  padding: 0 16px 120px;
  box-sizing: border-box;
}

.main-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0 8px;
  padding-bottom: 8px;
  border-bottom: 2px solid #ee0a24;

  span {
    font-size: 34px;
    color: #ee0a24;
    font-weight: 600;
    padding-left: 10px;
  }
}

.sub-tabs {
  display: flex;
  flex-wrap: wrap;
  margin-top: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;

  .sub-tab {
    font-size: 30px;
    font-weight: bold;
    color: #666;
    margin-right: 30px;
    padding: 0 10px;
    cursor: pointer;
    position: relative;

    &.active {
      color: #ee0a24;

      &::after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: -11px;
        height: 3px;
        background-color: #ee0a24;
      }
    }
  }
}

::v-deep .van-pagination {
  margin-top: 20px;
  padding-bottom: 24px;
  text-align: center;

  .van-pagination__item {
    color: $color-primary-text;
  }

  .van-pagination__item--active {
    background-color: $color-primary-text;
    color: #fff;
  }

  .van-pagination__item:active {
    background-color: $color-primary-text;
    color: #fff;
  }
}
</style>
